import React, { Component } from "react";
import "./ventas.css";
import "../registrosPage/ventas.css";
import { Col, Container, Row, } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Modal from 'react-modal'
import AltasModulePage from "./altas.module.page";
import AltasGralModulePage from "./altas.gral.module.page";
import CortesModulePage from "./cortes.module.page";
import ActualizaCostosModulePage from "./actualizacostos.module.page";
import TimeAgo from 'react-timeago'
import spanishStrings from 'react-timeago/lib/language-strings/es'
import buildFormatter from 'react-timeago/lib/formatters/buildFormatter'
import Loader from "react-loader-spinner";
const formatter = buildFormatter(spanishStrings)

const customStylesOption = { control: styles => ({ ...styles, backgroundColor: '#fff', width: '90%', height: 50, margin: '0 auto', marginBottom: 20, }), }
const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };


class RegistrosVentasPage extends Component {
  constructor(props) {
    super(props);
    this.__updateCosts = this.__updateCosts.bind(this)
    this.__updateByOPT = this.__updateByOPT.bind(this)
    this._handleKeyDown = this._handleKeyDown.bind(this)
    this.state = {
      __updateCosts: this.__updateCosts,
      __updateByOPT: this.__updateByOPT,
      localVentas: 0,
      arrProductos: [],
      searchProduct: '',
      arrListVenta: [],
      openInfoIndex: -1,

      arrayListResults: [],
      arrayListProductos: [],
      arrayListCategorias: [],
      arrayMinListProductos: [],
      arrayDespachadores: [],
      arrListProductosHoy: [],
      arrListVentaByID: [], //Listado de productos por id_pago
      indexAbonoPago: -1,
      arrListVentaAndPagosByID: {pagos: [], productos: {list: []}}, //Listado de productos y abonos por id_pago

      arrHistorialVentas: {list: [], total: 0},
      arrHistorialCortes: {list: [], total: 0},

      date: moment().format('YYYY-MM-DD'),

      //Modals
      isOpenCorte: false,
      isOpenAbono: false,
      isOpenViewInfoCortes: false,
      optInfoCortes: '',
      arrDataCorte: {},
      isOpenSearchProducto: false,
      isOpenPagarCompra: false,
      isOpenAltaProductos: false,
      isOpenAltaMovimientos: false,
      isOpenListVentaByID: false,

      arrHistoryEntradaAlmacen: { index: -1, list: [], productos: [], },

      id_motivo: -1,
      valorCorte: 0,
      valorAbono: 0,
      observacionCorte: '',
      observacionSolicitudCorte: '',
      observacionAbono: '',
      fpago: 4,
      //Info client
      nombreClienteCredito: {id_cliente: '', nombre: '', rfc: '',},
      nameCliente: '',
      genero: 1,
      prioridad: 1,
      email: '',

      cantidadRecibidaE: 0,
      cantidadRecibidaTD: 0,
      cantidadRecibidaTC: 0,

      arrayListClientes: [],
      numVentaGlobal: 0,
      indexItemByKeyboard: 0,

      //Entradas al almacen
      arrItemsAlmacen: [],
      fecha_entrada_almacen: moment().format('YYYY-MM-DD'),
      serie_almacen: '',
      referencia_almacen: '',
      noDocEntradaAlmacen: 0,

      valSearch: '',
      valSearchByFullCode: '',

      arrSucursales: [
        {id_sucursal: '5f2067c915291', nombre: 'BELLAVISTA', label: 'BELLAVISTA', value: 'BELLAVISTA', },
        {id_sucursal: '5f206899a20c8', nombre: 'INGENIO', label: 'INGENIO', value: 'INGENIO', },
        {id_sucursal: '5f2071cb03380', nombre: 'ECOCENTRAL', label: 'ECOCENTRAL', value: 'ECOCENTRAL', },
        {id_sucursal: '5f2071cb0ww32', nombre: 'RUTA', label: 'RUTA', value: 'RUTA', },
        {id_sucursal: '5f2073022efb6', nombre: 'MADERO', label: 'MADERO', value: 'MADERO', },
        {id_sucursal: 'almacen', nombre: 'ALMACEN', label: 'ALMACEN', value: 'ALMACEN', },
	{id_sucursal: 'almacen_gral', nombre: 'ALMACEN GRAL', label: 'ALMACEN GRAL', value: 'ALMACEN GRAL', },
        {id_sucursal: '5f2067c914482', nombre: 'GMART', label: 'GMART', value: 'GMART', },
        {id_sucursal: 'madero2', nombre: 'MADERO 2', label: 'MADERO 2', value: 'MADERO 2', },
      ],
      id_sucursal_destino: '',

      //Resumen cajero
      fecha_resumen_cajero: moment().format('YYYY-MM-DD'),

      //Last ventas
      isOpenLastVentas: false,
      arrLastVentas: [],


      //Formulario de facturación
      chBoxFacturarCompra: false,
      typePersonFactura: 0,
      f_razon_social: '',
      f_rfc: '',
      f_telefono: '',
      f_email: '',
      f_direccion_calle: '',
      f_direccion_colonia: '',
      f_direccion_noext: '',
      f_direccion_noint: '',
      f_direccion_cp: '',
      f_direccion_ciudad: '',
      f_direccion_estado: '',

      //Créditos
      arrCreditosAbonosVigentes: { clientes: [], creditos: [], index: -1, search: '', },


      //ALTAS ALMACEN
      indexItemByCombo: -1,
      indexItemByProceso: -1,
      arrAlmacenGral: [],
      arrProcesos: [],
      arrProductoSelectedByEntradaGral: {},
      isOpenSearchProductoByEntradaGral: false,
      arrProcesosDisponiblesByProducto: [],

      //Ver productos del proceso
      optViewProdByProc: 1, //Ver historico by default
      arrItemsProdByProc: [],
      arrProductosByTraspaso: [],
      arrTraspasosPendientes: [],
      arrTraspasosConfirmados: [],

    }

    this.keyBindingBtns = this.keyBindingBtns.bind(this);
  }

  componentDidMount() {
    //Petition wuuuu
    let { signedIn, } = this.props.initState
    
    this.getCostosByDate()
    document.addEventListener("keydown", this.keyBindingBtns, false);
    this.props.onRef(this)

  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.keyBindingBtns, false);
  }

  keyBindingBtns(event) {
    const { indexItemByKeyboard, arrayListResults, isOpenSearchProducto, isOpenPagarCompra, canPressF8, } = this.state
    const { renderView } = this.props.initState

    if(renderView !== 'nuevaCompraRuta')
      return false

    // [productos] F2  -> 113
    // [clientes]  F4  -> 115
    // [pagar]     F6  -> 117
    // [abonos]    F7  -> 118
    // [pagar]     F8  -> 119
    // [cancelar]  F9  -> 120
    // [ventas]    F10  -> 121
    // [nuevo]     F12 -> 123
    // [abajo]     ⬇  -> 40
    // [arriba]    ⬆  -> 38
    // [enter]     ⤵  -> 13
    // [tabulator] >  -> 9

    // event.preventDefault();
    if(event.keyCode === 113) {

      this.setBindProductos()
    } else if(event.keyCode === 115) {

      this.setState({isOpenListClientes: true})
      this.getListClientes()
    } else if(event.keyCode === 117 || event.keyCode === 119) {
      if(isOpenPagarCompra && canPressF8) {
        //Si está abierto el modal
        this.onRegisterNewVenta()
      } else {
        //Si no abrir modal
        this.setBindPago()
      }
    } else if(event.keyCode === 118) {
      //Abonos
      this.setBindCreditosAbonos(1)
    } else if(event.keyCode === 120) {
      //Cancelar
      this.setBindCancelar()
    } else if(event.keyCode === 121) {
      //last Ventas
      this.setBindLastVentas()
    } else if(event.keyCode === 40) {

      if(isOpenSearchProducto)
        this.setState({ indexItemByKeyboard: indexItemByKeyboard < (arrayListResults.length - 1) ? (indexItemByKeyboard + 1) : indexItemByKeyboard })
    } else if(event.keyCode === 38) {

      if(isOpenSearchProducto)
        this.setState({ indexItemByKeyboard: indexItemByKeyboard > 0 ? (indexItemByKeyboard - 1) : indexItemByKeyboard })
    } else if(event.keyCode === 13) {
      
      if(isOpenSearchProducto && arrayListResults.length > 0) {
        this.selectItemProduct(indexItemByKeyboard)
        this.setState({ indexItemByKeyboard: 0, })
      } else if(isOpenPagarCompra) {
        // this.onRegisterNewVenta()
      } else {
        this.inputSearchByCode.focus();
      }
    } else if(event.keyCode === 9) {
      if( document.activeElement.id === 'ws-input-search-code' ) {
        this.onSearchProductoByCode()
        event.preventDefault()
      }
    }

  }

  getListClientes() {
    const { signedIn, debug, } = this.props.initState
    const data = { id_sucursal: signedIn.id_sucursal, }

    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getListClientes", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrayListClientes: response, })
    }).catch((error) => console.info(error));
  }

  getCostosByDate() {
    const { signedIn, debug, } = this.props.initState
    const { date, arrListVenta, } = this.state

    const data = {
      user: signedIn.id_sucursal,
      id_vendedor: signedIn.id_usuario,
      id_sucursal: signedIn.id_sucursal,
      date,
      arrListVenta: arrListVenta,
    }

    if(debug === 1) {
      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=getRelationCostosByDate", this.headersPOST({ })).then(response0 => response0.json()).then((response0) => {const response = response0;let { countTotal, countUpdate, arrayListProductos, arrayListCategorias, noDocEntradaAlmacen, arrayDespachadores } = response;let arrayMinListProductos = [];for(var a in arrayListProductos) {arrayMinListProductos.push({id_producto: arrayListProductos[a].id_producto,label: arrayListProductos[a].nombre,value: arrayListProductos[a].nombre,});if(a == (arrayListProductos.length - 1)) {this.setState({countTotal,countUpdate,arrayListProductos,arrayListCategorias,arrayMinListProductos,noDocEntradaAlmacen,arrayDespachadores,});}}})
      return false
    }

    //Solicitamos siempre información actualizada.
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getRelationCostosByDate", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {

      let { countTotal, countUpdate, arrayListProductos, arrayListCategorias, noDocEntradaAlmacen, arrayDespachadores, arrListVenta, numVentaGlobal, url_facturacion, arrTraspasosPendientes, arrListProductosHoy, } = response
      //Minificamos el listado de productos (util para entradas al almacen)
      let arrayMinListProductos = []

      // getListProductosByArr

      for(var a in arrayListProductos) {
        arrayMinListProductos.push({
          id_producto: arrayListProductos[a].id_producto,
          label: arrayListProductos[a].nombre,
          value: arrayListProductos[a].nombre,
        })

        if(a == (arrayListProductos.length - 1)) {
          //Verificamos si hay que actualizar costos de productos ya vendiendo
          this.setState({
            arrayListResults: [],
            numVentaGlobal,
            countTotal,
            countUpdate,
            arrayListProductos,
            arrayListCategorias,
            arrayMinListProductos,
            noDocEntradaAlmacen,
            arrayDespachadores,
            arrListVenta,
            arrTraspasosPendientes,
            arrListProductosHoy,
          })
          //FALTA ACTUALIZAR LISTADO DE COSTOS EN VENTA

          this.props.initsetState({ updateApp: {stat: false, text: '', countFileLocalUpdated: 0, onlySync: true, }, url_facturacion, })
          localStorage.setItem('url_facturacion', url_facturacion)

          //Enviamos el resultado al localserver para almacenar por si es necesario
        }
      }

    }).catch((error) => {
      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=getRelationCostosByDate", this.headersPOST({ }))
      .then(response0 => response0.json()).then((response0) => {
        const response = response0
        let { countTotal, countUpdate, arrayListProductos, arrayListCategorias, noDocEntradaAlmacen, arrayDespachadores } = response
        //Minificamos el listado de productos (util para entradas al almacen)
        let arrayMinListProductos = []

        for(var a in arrayListProductos) {
          arrayMinListProductos.push({
            id_producto: arrayListProductos[a].id_producto,
            label: arrayListProductos[a].nombre,
            value: arrayListProductos[a].nombre,
          })

          if(a == (arrayListProductos.length - 1)) {
            this.setState({
              countTotal,
              countUpdate,
              arrayListProductos,
              arrayListCategorias,
              arrayMinListProductos,
              noDocEntradaAlmacen,
              arrayDespachadores,
            })

            fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=getLocalVentas", this.headersPOST({...data}))
            .then(response => response.json())
            .then((response) => {
              this.setState({ localVentas: response })
            })

          }
        }
      })
      .catch(e0 => {
      })
    })
  }

  __updateCosts() {
    //Firsts get all costs
    this.getCostosByDate()
  }

  __updateByOPT(opt) {
    const { signedIn, } = this.props.initState

    if(opt === 'setUpdateEntradasAlmacen') {
      //Notificación de nueva entrada al almacen
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getTraspasosPendientesGralByIDSucursal", this.headersPOST({ id_sucursal: signedIn.id_sucursal, }))
      .then(response => response.json())
      .then((response) => {
        let arrTraspasosPendientes = response.list
        this.setState({
          arrTraspasosPendientes,
        })
      }).catch((error) => console.info(error));

    }
  }

  onListHistorialDia() {
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getHistorialVentasDia", this.headersPOST({ }))
    .then(response => response.json())
    .then((response) => {
      let { arrProductos, } = response
      this.setState({
        arrProductos,
      })
    }).catch((error) => console.info(error));
  }

  setBindProductos() {
    this.setState({isOpenSearchProducto: true})
    setTimeout(() => {
      this.inputSearchProducto.focus(); 
    }, 100)
  }

  setBindCancelar() {
    var opcion = window.confirm("¿Estás seguro que deseas cancelar esta venta?");
    if (opcion == true) {
      const { signedIn } = this.props.initState
      this.setState({
        arrListVenta: [],
      })
      // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 0, })
    }
  }

  setBindPago() {
    let { arrListVenta } = this.state
    let cantidadTotal = 0, 
    flag = -1
    arrListVenta.map((t, e) => {
      cantidadTotal += ( t.precio * t.cantidad );
      if(t.cantidad === "")
        flag = e
    })

    if(flag > -1) {
      this[`inputVentaID${(flag)}`].focus();
    } else {
      if(cantidadTotal > 0) {
        this.setState({
          canPressF8: true,
          isOpenPagarCompra: true,
          fpago: 4,
          cantidadRecibidaE: this.number_format(cantidadTotal, 2, '.', ''),
          cantidadRecibidaTC: 0,
          cantidadRecibidaTD: 0,
        }, this.getListClientes)
        setTimeout(() => {
          // this.inputCambioRecibido.focus();
        }, 100)
      }
    }
  }

  setBindCreditosAbonos(opt, index) {
    this.setState({ isOpenCreditosAbonos: true, })
    const { signedIn } = this.props.initState
    let { arrCreditosAbonosVigentes } = this.state
    let data = {}

    if(opt == 1)
      data = { opt: 1, id_sucursal: signedIn.id_sucursal, }
    else if(opt == 2) {
      let { id_cliente, } = arrCreditosAbonosVigentes.clientes[
        typeof index !== 'undefined' ? index : arrCreditosAbonosVigentes.index
      ]

      data = { opt: 2, id_cliente, }
    }

    fetch(this.getURLByOPT('getCreditosAbonosVigentes'), this.headersPOST({...data}))
    .then(response => response.json()).then((response) => {
      if(opt === 1) {
        arrCreditosAbonosVigentes.clientes = response
      } else {
        if(typeof index !== 'undefined') {
          arrCreditosAbonosVigentes.index = index
        }
        arrCreditosAbonosVigentes.creditos = response
      }
      this.setState({ arrCreditosAbonosVigentes, })
    }).catch(err => {
    })

  }

  setBindLastVentas() {
    this.setState({isOpenLastVentas: true, })
    const { date } = this.state
    const { signedIn } = this.props.initState
    const data = {
      date,
      id_usuario: signedIn.id_usuario,
      nombre_cajero: (signedIn.nombre + ' ' + signedIn.apellidos),
    }
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getLastVentas", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrLastVentas: response, })
    })
  }

  render() {
    const {
      arrListVenta, openInfoIndex, isOpenCorte, isOpenSearchProducto,
      isOpenPagarCompra, isOpenListClientes, arrayListClientes, numVentaGlobal,
      cantidadRecibidaE, cantidadRecibidaTD, cantidadRecibidaTC,
    } = this.state

    let { renderView, updateApp, isCambioCostos, } = this.props.initState

    //Si se manda una orden de actualización todo desaparece
    if(updateApp.stat) {
      return (
        <div style={{ margin: '0 auto', width: '100%', marginTop: 100, backgroundColor: '#fff', }}>
          <Row style={{ textAlign: 'center' }}>
            <p style={{ width: '100%', }}>{updateApp.text}</p>
          </Row>
          <Row style={{ margin: '0 auto', width: '100%', justifyContent: 'center', alignItems: 'center', display: 'flex', }}>
            <Loader
              type="Puff"
              color="#00BFFF"
              height={100}
              width={100}
              timeout={0} //3 secs
            />
          </Row>
        </div>
      )
    }

    let cantidadTotal = 0,
    cantidadCambio = 0,
    cantidadCambioCredito = 0

    /* General view, nueva compra - últimas compras */
    if(renderView === 'general') {
      return (
        <CortesModulePage
          onRef={ref => (this.refCorte = ref)}
          subState={ this.state } subSetState={ (param) => this.setState(param) } initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />
      );
    } else if(renderView === 'nuevaCompraRuta') {
      let { valSearch, valSearchByFullCode, arrayListResults, indexItemByKeyboard, localVentas, fpago, isOpenLastVentas,
        nombreClienteCredito, isOpenListVentaAndPagosByID, isOpenRegisterAbonoPago, isOpenCreditosAbonos, arrLastVentas, arrCreditosAbonosVigentes, cantidadTotalCredito, arrTraspasosPendientes, arrListProductosHoy, showProductosHoy, } = this.state

      arrListVenta.map((t) => { cantidadTotal += ( t.precio * t.cantidad )})
      cantidadCambio = ((parseFloat(cantidadRecibidaE == '' ? 0 : cantidadRecibidaE) + parseFloat(cantidadRecibidaTD == '' ? 0 : cantidadRecibidaTD) + parseFloat(cantidadRecibidaTC == '' ? 0 : cantidadRecibidaTC) ) - cantidadTotal )
      cantidadCambioCredito = ((parseFloat(cantidadRecibidaE == '' ? 0 : cantidadRecibidaE) + parseFloat(cantidadRecibidaTD == '' ? 0 : cantidadRecibidaTD) + parseFloat(cantidadRecibidaTC == '' ? 0 : cantidadRecibidaTC) ) - cantidadTotalCredito )
      return (
        <>
          { /*isCambioCostos && arrListVenta.length === 0 ? this.makeAvisoReload() : null */}
          <Row style={{ padding: 10, background: '#fff', margin: 0, }}>
            <Col>
              <p style={{ margin: 0, }}>{ numVentaGlobal }</p>
              <p style={{ margin: 0, }}>Número de venta</p>
              <b onClick={() => {
                const isActive = this.props.initState.printerActive === 1 ? 0 : 1;
                localStorage.setItem('printerActive', isActive);
                this.props.initsetState({ printerActive: isActive, });
              }} style={{ cursor: 'pointer', margin: 0, }}>{this.props.initState.printerActive === 1 ? 'Pulsa para desactivar impresora' : 'Pulsa para activar impresora'}</b>
            </Col>
            <Col>
              <p style={{ margin: 0, }}>Cambio de costos hoy: ({arrListProductosHoy.length})</p>
              <b style={{ cursor: 'pointer', margin: 0, }} onClick={() => { this.setState({ showProductosHoy: !showProductosHoy, }) }}>Visualizar</b>
            </Col>
            <Col style={{ textAlign: 'right' }}>
              <p style={{ margin: 0, fontSize: '.8rem' }}>{this.props.initState.appConnected ? 'Conectado a internet' : 'NO CONECTADO A INTERNET'}</p>
              <p style={{ margin: 0, fontSize: '.8rem' }}>Registros sin enviar: {localVentas}</p>
              <p style={{ margin: 0, fontSize: '.8rem' }}>v321.06.07</p>
            </Col>
          </Row>
          <Row style={{ padding: 4, background: '#000', margin: 0, cursor: 'pointer', }}>
            <Col onClick={ () => { this.setBindProductos() }}>
              <p className={'ws-badge-btn-action'}>F2</p>
              <p style={{ margin: 0, color: '#fff', textAlign: 'center', fontWeight: '800', }}>Productos</p>
            </Col>
            {
              /*
              <Col>
                <p className={'ws-badge-btn-action'}>F4</p>
                <p style={{ margin: 0, color: '#fff', textAlign: 'center', fontWeight: '800', }}>Clientes</p>
              </Col>
              */
            }
            <Col onClick={ () => { this.setBindCreditosAbonos(1) }}>
              <p className={'ws-badge-btn-action'}>F7</p>
              <p style={{ margin: 0, color: '#fff', textAlign: 'center', fontWeight: '800', }}>Abonos</p>
            </Col>
            <Col onClick={ () => { this.setBindCancelar() }}>
              <p className={'ws-badge-btn-action'}>F9</p>
              <p style={{ margin: 0, color: '#fff', textAlign: 'center', fontWeight: '800', }}>Cancelar</p>
            </Col>

            <Col onClick={ () => { this.setBindLastVentas() }}>
              <p className={'ws-badge-btn-action'}>F10</p>
              <p style={{ margin: 0, color: '#fff', textAlign: 'center', fontWeight: '800', }}>Ventas</p>
            </Col>
            {
              cantidadTotal > 0 ? (
                <Col onClick={ () => { this.setBindPago() }}>
                  <p className={'ws-badge-btn-action'}>F8</p>
                  <p style={{ margin: 0, color: '#fff', textAlign: 'center', fontWeight: '800', }}>Crear orden de envío</p>
                </Col>
              ) : null
            }
            
          </Row>

          <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', display: showProductosHoy ? 'none': 'block' }}>
            {/* Principal Container */}
            <Row style={{ width: '99%', margin: '0 auto' }}>
              <Col className={'z-depth-1'} style={{ background: '#fff', }}>
                {
                  arrListVenta.length === 0 ? (
                    <Row>
                      <p className="regVentaPage__product" style={{ padding: '0px', textAlign: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', height: '100%', }}>Para comenzar ingresa un producto</p>
                      <input
                        type="text"
                        id={'ws-input-search-code'}
                        autoComplete="off"
                        placeholder="Ingresa el código del producto..."
                        value={valSearchByFullCode}
                        onChange={(e) => { this.setState({ valSearchByFullCode: e.target.value }) } }
                        onKeyDown={this._handleKeyDown}
                        ref={(input) => { this.inputSearchByCode = input;  }}
                        style={{ margin: '20px auto', width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                      />
                    </Row>
                  ) : (
                    <>
                      <p className="regVentaPage__product" style={{ padding: 0, }}>Total a cobrar</p>
                      <p className="regVentaPage__productPrice" style={{ padding: 0, }}>${ this.number_format(cantidadTotal, 2) }</p>

                      <Row>
                        <Col xs={'4'}>
                          <b>Nombre</b>
                        </Col>
                        <Col xs={'3'}>
                          <b>Cantidad</b>
                        </Col>
                        <Col xs={'2'}>
                          <b>Precio</b>
                        </Col>
                        <Col xs={'3'}>
                          <b style={{ display: 'block', width: '100%', textAlign: 'right', }}>Total</b>
                        </Col>
                      </Row>
                      {
                        arrListVenta.map((t,e) => (
                          <Row
                            key={`ws_list_compra_${e}`}
                            style={{ width: '100%', margin: '0 auto', marginTop: 10, marginBottom: 10, }}
                            className="regVentaPage__content"
                          >
                            <div className="regVentaPage__separator"></div>

                            <Col xs={'4'} className="regVentaPage__listProduct">
                              {
                                t.canEditProduct ? (
                                  <>
                                    <input
                                      value={t.folio}
                                      onChange={ (eInput) => { this.onUpdateFolio(t, e, eInput.target.value) } }
                                      type={"text"}
                                      placeholder={"Ingresa el folio..."}
                                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                                    />
                                    <p style={{ color: '#333' }}>{t.only_nombre}</p>
                                  </>
                                ) : (
                                  <p style={{ color: '#333' }}>{t.folio} - {t.only_nombre}</p>
                                )
                              }
                              {
                                t.update == 0
                                ? <p style={{ fontSize: '.8rem', lineHeight: '15px', }}>El costo aún no ha sido actualizado</p>
                                : null
                              }
                            </Col>
                            <Col xs={'3'} className="regVentaPage__listProduct">
                              <input
                              ref={input => {
                                this[`inputVentaID${e}`] = input;
                              }}
                              value={t.cantidad}
                              onChange={ (eInput) => { this.onUpdateCantidad(t, e, eInput.target.value) } }
                              type={"text"}
                              placeholder={"Ingresa la cantidad..."}
                              style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }} />
                            </Col>
                            <Col xs={'2'} className="regVentaPage__listProduct">
                              {
                                t.canEditProduct ? (
                                  <>
                                    <input
                                      value={t.precio}
                                      onChange={ (eInput) => { this.onUpdatePrecio(t, e, eInput.target.value) } }
                                      type={"text"}
                                      placeholder={"Ingresa el precio..."}
                                      style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                                    />
                                    <p style={{ fontWeight: 800, margin: 0, fontSize: '.7rem', lineHeight: '12px', }} onClick={() => { this.onUpdateBuy( e, !t.applyOnlyBuy ) }} >{
                                      t.applyOnlyBuy ? 'Solo para esta venta' : 'Actualizar en inventario'
                                    }</p>
                                  </>
                                ) : (
                                  <p style={{ color: '#333' }}>${this.number_format(t.precio,2)}</p>
                                )
                              }
                            </Col>
                            <Col xs={'3'} className="regVentaPage__listProduct">
                              <p style={{ fontWeight: 800, fontSize: 14, textAlign: 'right', paddingRight: 10, }}>${ this.number_format( (t.precio * t.cantidad) , 2) }</p>
                              <p
                                style={{ cursor: 'pointer', color: 'red', fontWeight: '800', position: 'absolute', right: 0, top: '5px', zIndex: 1, }}
                                onClick={() => { this.deleteItemProduct(e) }}
                              >X</p>
                              <p
                                style={{ cursor: 'pointer', color: '#777', fontWeight: '800', position: 'absolute', right: '25px', top: '30px', zIndex: 1,  }}
                                onClick={() => { this.onEditValuesProduct( e, !t.canEditProduct ) }}
                              >Editar</p>
                            </Col>
                          </Row>
                        ))
                      }

                      <Row style={{ background: '#fff', paddingBottom: 0, marginBottom: 0, }}>
                        <input
                          type="text"
                          id={'ws-input-search-code'}
                          autoComplete="off"
                          placeholder="Ingresa el código del producto..."
                          value={valSearchByFullCode}
                          onChange={(e) => { this.setState({ valSearchByFullCode: e.target.value }) } }
                          onKeyDown={this._handleKeyDown}
                          ref={(input) => { this.inputSearchByCode = input;  }}
                          style={{ margin: '20px auto', width: '100%', background: '#f3f3f3', border: '1px solid #ccc', borderRadius: 4, }}
                        />
                      </Row>
                    </>
                  )
                }

              </Col>

              <Col md={'3'} style={{ background: '#fff', padding: 15, textAlign: 'center', }} className={'z-depth-1'}>
                {
                  arrTraspasosPendientes.length > 0 ? (
                    <div className={'btn btn-primary'} onClick={() => { this.props.initsetState({ renderView: 'altas', }) }}>
                      <b>AVISO</b>
                      <p style={{ width: '80%', display: 'block', margin: '0 auto', whiteSpace: 'pre-line', }}>Tienes {arrTraspasosPendientes.length} { ` ${arrTraspasosPendientes.length === 1 ? 'traspaso pendiente' : 'traspasos pendientes'} ` } por confirmar haz click aquí para ir.</p>
                    </div>
                  ) : null
                }
                {
                  isCambioCostos ? (
                    <div className={'btn btn-primary'} onClick={() => { this.props.initsetState({ renderView: 'altas', }) }}>
                      <b>AVISO</b>
                      <p style={{ width: '80%', display: 'block', margin: '0 auto', whiteSpace: 'pre-line', }}>Algunos precios han cambiado en este punto de venta. Te recomendamos lo actualices.</p>
                      <button className={'btn btn-danger'} onClick={() => {
                        window.location.reload()
                      }}>Actualizar</button>
                    </div>
                  ) : null
                }
                <img src="img/hgapp/logohg.png" alt="banner" style={{ width: '70%', height: '70%', objectFit:'contain', borderRadius: '100%', padding: 5, }} />
                <div className={'viewCountCobranza'}>
                  <p className="regVentaPage__product" style={{ padding: 0, }}>Total a cobrar</p>
                  <p className="regVentaPage__productPrice" style={{ padding: 0, }}>${ this.number_format(cantidadTotal, 2) }</p>
                </div>
              </Col>

            </Row>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={isOpenSearchProducto}
              onRequestClose={() => { this.setState({isOpenSearchProducto: false}) }}
              style={customStyles}
              contentLabel="Seleccionar un producto"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>
                    <h4 style={{ margin: 0, }}>Seleccionar un producto</h4>
                    <input
                      type="text"
                      placeholder="Ingresa el nombre del producto..."
                      value={valSearch}
                      onChange={(e) => this.onViewProduct(e.target.value) } 
                      ref={(input) => { this.inputSearchProducto = input; }}
                      style={{ margin: '20px auto', }}
                    />

                    <Row>
                      <Col xs={'5'}>
                        <b>Nombre</b>
                      </Col>
                      <Col xs={'2'}>
                        <b>Categoría</b>
                      </Col>
                      <Col xs={'2'}>
                        <b>P. Venta</b>
                      </Col>
                      <Col xs={'3'}>
                        <b>Fecha actualizado</b>
                      </Col>
                    </Row>
                    {
                      arrayListResults.map((t,e) => (
                        <div key={`ws_list_compra_${e}`}>
                          <Row
                            onClick={ () => { this.selectItemProduct(e) } }
                            style={{ width: '100%', margin: '0 auto', marginTop: 5, }}
                            className={`regVentaPage__content ${e === indexItemByKeyboard ? 'regVentaPage__content__active' : null}`}
                          >
                            <div className="regVentaPage__separator"></div>
                            <Col xs={'5'} className="regVentaPage__listProduct">
                              <p style={{ color: '#333', margin: 0, }}>{t.nombre}</p>
                            </Col>
                            <Col xs={'2'} className="regVentaPage__listPrices">
                              <p style={{ color: '#333', margin: 0, }}>{t.categoria}</p>
                            </Col>
                            <Col xs={'2'} className="regVentaPage__listPrices">
                              <p style={{ color: '#333', margin: 0, fontWeight: '800' }}>${this.number_format(t.precio_venta, 2)}</p>
                            </Col>
                            <Col xs={'3'} className="regVentaPage__listPrices">
                              <TimeAgo
                                style={{ color: (t.update == 1 ? '#16a085' : '#444'), }}
                                className="__listViewPending_time" date={t.fecha_cambio_costo} formatter={formatter}
                              />
                              {
                                t.update == 0
                                ? <p style={{ fontSize: '.8rem', }}>El costo aún no ha sido actualizado</p>
                                : null
                              }
                            </Col>
                          </Row>
                        </div>
                      ))
                    }

                  </Col>
                </Row>
              </div>
            </Modal>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={isOpenPagarCompra}
              onRequestClose={() => { this.setState({isOpenPagarCompra: false}) }}
              style={customStyles}
              contentLabel="Crear orden de envío"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>
                    <h4 style={{ margin: 0, marginBottom: 10, }}>Crear orden de envío</h4>

                    <hr />
                    {
                      fpago === 4 ? (
                        <>
                          {
                            arrayListClientes.length > 0 ? (
                              <Select
                                onChange={(item) => {
                                  this.setState({ nombreClienteCredito: { ...item, } });
                                }}
                                placeholder={'Selecciona un cliente'}
                                options={[
                                  { id_cliente: '0', label: 'Nuevo cliente', value: 'Nuevo cliente', },
                                  ...arrayListClientes
                                ]}
                                styles={customStylesOption}
                              />
                            ) : (
                              <p>Obteniendo clientes, espera un momento...</p>
                            )
                          }
                          {
                            nombreClienteCredito.id_cliente === '0' ? (
                              <>
                                <hr />
                                <input
                                  type="text"
                                  placeholder="Ingresa el RFC (obligatorio) *"
                                  onChange={ (event) => { nombreClienteCredito.rfc = event.target.value; this.setState({ nombreClienteCredito, }) } }
                                  style={{ margin: '20px auto', }}
                                />
                                <hr />
                                <input
                                  type="text"
                                  placeholder="Ingresa el nombre del cliente *"
                                  onChange={ (event) => { nombreClienteCredito.nombre = event.target.value; this.setState({ nombreClienteCredito, }) } }
                                  style={{ margin: '20px auto', }}
                                />
                              </>
                            ) : null
                          }
                        </>
                      ) : null
                    }
                    <hr />
                    <hr />

                    <div className={'ventasPage__facturaCheck'} onClick={() => { this.setState({chBoxFacturarCompra: !this.state.chBoxFacturarCompra, }) }}>
                      <p>Facturar esta compra</p>
                      <input type="checkbox" defaultChecked={this.state.chBoxFacturarCompra} value={this.state.chBoxFacturarCompra}  />
                    </div>

                    {
                      this.state.chBoxFacturarCompra ? (
                        <Row className={"modalBody__corte ventasPage__facturaViewForm"}> 
                          <Col>
                            <h4>Ingresa los datos solicitados</h4>
                            <Select
                              onChange={(item) => { this.setState({ typePersonFactura: item.typePersonFactura }) }}
                              placeholder={'Tipo de persona'}
                              options={[
                                { typePersonFactura: 1, label: 'Persona física', value: 'Persona física' },
                                { typePersonFactura: 2, label: 'Persona moral', value: 'Persona moral' },
                                ]}
                              styles={customStylesOption}
                            />

                            <Row>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Razón social" onChange={ (event) => { this.setState({ f_razon_social: event.target.value, })} } /></Col>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="RFC" onChange={ (event) => { this.setState({ f_rfc: event.target.value, })} } /></Col>
                            </Row>
                            <Row>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Teléfono" onChange={ (event) => { this.setState({ f_telefono: event.target.value, })} } /></Col>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Correo electrónico" onChange={ (event) => { this.setState({ f_email: event.target.value, })} } /></Col>
                            </Row>
                            <Row>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Calle" onChange={ (event) => { this.setState({ f_direccion_calle: event.target.value, })} } /></Col>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Colonia" onChange={ (event) => { this.setState({ f_direccion_colonia: event.target.value, })} } /></Col>
                            </Row>
                            <Row>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Nº Exterior" onChange={ (event) => { this.setState({ f_direccion_noext: event.target.value, })} } /></Col>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Nº Interior" onChange={ (event) => { this.setState({ f_direccion_noint: event.target.value, })} } /></Col>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Código postal" onChange={ (event) => { this.setState({ f_direccion_cp: event.target.value, })} } /></Col>
                            </Row>
                            <Row>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Ciudad" onChange={ (event) => { this.setState({ f_direccion_ciudad: event.target.value, })} } /></Col>
                              <Col><input style={{ marginTop: 0 }} type="text" placeholder="Estado" onChange={ (event) => { this.setState({ f_direccion_estado: event.target.value, })} } /></Col>
                            </Row>

                          </Col>
                        </Row>
                      ) : null
                    }

                    <button onClick={ () => { this.onRegisterNewVenta() }} className="btn btn-primary regVentaPage__title_ruta">Registrar orden</button>
                  </Col>
                </Row>
              </div>
            </Modal>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={isOpenLastVentas}
              onRequestClose={() => { this.setState({isOpenLastVentas: false}) }}
              style={customStyles}
              contentLabel="Últimas ventas"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>
                    <h4 style={{ margin: 0, marginBottom: 10, }}>Últimas ventas</h4>
                    
                    <Row>
                      <Col><p>ID Venta</p></Col>
                      <Col><p>Totales</p></Col>
                      <Col><p>Fecha</p></Col>
                      <Col><p>Opciones</p></Col>
                    </Row>

                    {
                      arrLastVentas.map((t,e) => (
                        <Row>
                        <hr style={{ clear: 'both', }} />
                          <Col>
                            { t.fpago == 4 ? (<p>Nota de venta a crédito</p>) : null }
                            <p>{t.id_pago}</p>
                          </Col>
                          <Col>
                            { t.cantidadRecibidaE != '0' ? <p style={{ margin: 0, }}>Efectivo: ${this.number_format(t.cantidadRecibidaE,2)}</p> : null }
                            { t.cantidadRecibidaTD != '0' ? <p style={{ margin: 0, }}>Débito: ${this.number_format(t.cantidadRecibidaTD,2)}</p> : null }
                            { t.cantidadRecibidaTC != '0' ? <p style={{ margin: 0, }}>Crédito: ${this.number_format(t.cantidadRecibidaTC,2)}</p> : null }
                            <b style={{ margin: 0, }}>TOTAL: ${this.number_format(
                              parseFloat(t.cantidadRecibidaE) + parseFloat(t.cantidadRecibidaTD) + parseFloat(t.cantidadRecibidaTC)
                              ,2)}</b>
                          </Col>
                          <Col><p>{moment(t.date).format('DD/MM/YYYY HH:mm:ss')}</p></Col>
                          <Col>
                            <p
                              style={{ marginLeft: 5, }}
                              className={'btn btn-primary'}
                              onClick={ () => {
                                fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getListProductosByID", this.headersPOST({ id_pago: t.id_pago, }))
                                .then(response => response.json())
                                .then((response) => {
                                  t.arr = response
                                  t.printerActive = this.props.initState.printerActive
                                  fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setPrintLastVenta", this.headersPOST({...t}))
                                  .then(response0 => response0.json())
                                  .then((response0) => {alert('Impresión realizada')})
                                })
                              }}
                            >Imprimir ticket</p>
                            <p
                              style={{ marginLeft: 5, }}
                              className={'btn btn-primary'}
                              onClick={ () => { this.getListProductosByID(t.id_pago) }}
                            >Visualizar</p>
                            <p
                              style={{ marginLeft: 5, }}
                              className={'btn btn-secondary'}
                              onClick={ () => { this.setDevolucionVentaByID(t.id_pago) }}
                            >Devolución</p>
                            <p
                              style={{ marginLeft: 5, }}
                              className={'btn btn-danger'}
                              onClick={ () => { this.setDeleteVentaByID(t.id_pago) }}
                            >Eliminar</p>
                          </Col>
                        </Row>
                      ))
                    }

                    <button style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2ecc71', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', marginTop: 20, display: 'block', border: 0, }}
                    onClick={ () => { this.setState({ isOpenLastVentas: false }) }}
                    className="regVentaPage__title">Cerrar</button>

                  </Col>
                </Row>
              </div>
            </Modal>
  
            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={isOpenCreditosAbonos}
              onRequestClose={() => { this.setState({isOpenCreditosAbonos: false}) }}
              style={customStyles}
              contentLabel="Clientes"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  {
                    arrCreditosAbonosVigentes.index === -1 ? (
                      <Col>
                        <h4 style={{ margin: 0, marginBottom: 10, }}>Clientes</h4>
                        <input type={'text'}
                          placeholder={'Buscar un cliente...'}
                          value={arrCreditosAbonosVigentes.search}
                          onChange={ (event) => { arrCreditosAbonosVigentes.search = event.target.value; this.setState({ arrCreditosAbonosVigentes }) }}
                          style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
                        />
                        <Row>
                          <Col xs={8}><b>Nombre del cliente</b></Col>
                          <Col><p>Opciones</p></Col>
                        </Row>
                        {
                          arrCreditosAbonosVigentes.clientes.map((t,e) => (
                            <>
                            {
                              arrCreditosAbonosVigentes.search === '' || 
                              t.nombre && t.nombre.trim().toLowerCase().indexOf(arrCreditosAbonosVigentes.search.toLowerCase()) !== -1 ? (
                                <Row className={'ventasPage__listProductos'}>
                                  <Col xs={8}>
                                    {
                                      t.editName ? (
                                        <>
                                          <input type={'text'} value={t.nombre} onChange={(event) => { t.nombre = event.target.value; this.setState({ arrCreditosAbonosVigentes }); }} />
                                          <span onClick={ () => { t.editName = !t.editName; this.setState({ arrCreditosAbonosVigentes, }); this.saveClienteCredito(t,e) }} className={`ws__edit_name_client`}>Guardar</span>
                                        </>
                                      ) : (
                                        <>
                                          <b>{t.nombre}</b>
                                          <span onClick={ () => { t.editName = !t.editName; this.setState({ arrCreditosAbonosVigentes, }) }} className={`ws__edit_name_client`}>Editar</span>
                                        </>
                                      )
                                    }
                                  </Col>
                                  <Col>
                                    <button
                                      style={{ marginLeft: 5, marginBottom: 4, width: '100%', }}
                                      className={'btn btn-secondary'}
                                      onClick={ () => { this.setBindCreditosAbonos(2, e) }}
                                    >Ver créditos</button>
                                  </Col>
                                </Row>
                              ) : null
                            }
                            </>
                          ))
                        }
                        <button style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2ecc71', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', marginTop: 20, display: 'block', border: 0, }}
                        onClick={ () => { this.setState({ isOpenCreditosAbonos: false }) }}
                        className="regVentaPage__title">Cerrar</button>
                      </Col>
                    ) : (
                      <Col>
                        <h4 style={{ margin: 0, marginBottom: 10, }}>Créditos de { arrCreditosAbonosVigentes.clientes[arrCreditosAbonosVigentes.index].nombre.toUpperCase() }</h4>
                        <p style={{ margin: 0, marginTop: 10, marginBottom: 10, cursor: 'pointer', fontWeight: '800', }} onClick={ () => { arrCreditosAbonosVigentes.index = -1; this.setState({ arrCreditosAbonosVigentes, }) }}>Regresar</p>
                        <Row>
                          <Col><b>Folio</b></Col>
                          <Col><p>Fecha de compra</p></Col>
                          <Col><p>Total de prestado</p></Col>
                          <Col><p>Abonos</p></Col>
                          <Col><p>Restante</p></Col>
                          <Col><p>Opciones</p></Col>
                        </Row>

                        {
                          arrCreditosAbonosVigentes.creditos.map((t,e) => (
                            <Row className={'ventasPage__listProductos'}>
                              <Col><b>{t.folio}</b></Col>
                              <Col><p>{moment(t.date).format('DD/MM/YYYY HH:mm:ss')}</p></Col>
                              <Col>
                                <p style={{ margin: 0, }}>${this.number_format(t.total_credito,2)}</p>
                              </Col>
                              <Col>
                                { t.cantidadRecibidaE != '0' ? <p style={{ margin: 0, }}>Efectivo: ${this.number_format(t.cantidadRecibidaE,2)}</p> : null }
                                { t.cantidadRecibidaTD != '0' ? <p style={{ margin: 0, }}>Débito: ${this.number_format(t.cantidadRecibidaTD,2)}</p> : null }
                                { t.cantidadRecibidaTC != '0' ? <p style={{ margin: 0, }}>Crédito: ${this.number_format(t.cantidadRecibidaTC,2)}</p> : null }
                                <b style={{ margin: 0, }}>TOTAL: ${this.number_format(
                                  parseFloat(t.cantidadRecibidaE) + parseFloat(t.cantidadRecibidaTD) + parseFloat(t.cantidadRecibidaTC)
                                  ,2)}</b>
                              </Col>
                              <Col>
                                <p style={{ margin: 0, }}>${this.number_format(t.residual,2)}</p>
                              </Col>
                              <Col>
                                <button
                                  style={{ marginLeft: 5, marginBottom: 4, width: '100%', }}
                                  className={'btn btn-secondary'}
                                  onClick={ () => { this.getListProductosAndPagosByID(t.id_pago) }}
                                >Ver historial de pagos</button>
                                <button
                                  style={{ marginLeft: 5, marginBottom: 4, width: '100%', }}
                                  className={'btn btn-primary'}
                                  onClick={ () => { this.setRegisterAbono(e) }}
                                >Realizar abono</button>
                              </Col>
                            </Row>
                          ))
                        }
                        <button style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2ecc71', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', marginTop: 20, display: 'block', border: 0, }}
                        onClick={ () => { this.setState({ isOpenCreditosAbonos: false }) }}
                        className="regVentaPage__title">Cerrar</button>
                      </Col>
                    )
                  }
                </Row>
              </div>
            </Modal>
  
            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={isOpenListClientes}
              onRequestClose={() => { this.setState({isOpenListClientes: false}) }}
              style={customStyles}
              contentLabel="Clientes registrados"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>
                    <h4 style={{ margin: '10px 0', }}>Clientes registrados</h4>
                    
                    <Row>
                      <Col xs={'10'}>
                        <b>Nombre</b>
                      </Col>
                      <Col xs={'2'}>
                        <b>Acciones</b>
                      </Col>
                    </Row>
                    {
                      arrayListClientes.map((t,e) => (
                        <div key={`ws_list_compra_${e}`} style={{ marginTop: 5, }}>
                          <Row>
                            <Col xs={'10'} className="regVentaPage__listProduct">
                              <input type={'text'} value={t.nombre} style={{ margin: 0, }} onChange={(ev) => {
                                arrayListClientes[e].nombre = ev.target.value
                                this.setState({ arrayListClientes, });
                              }} />
                            </Col>
                            <Col xs={'2'} className="regVentaPage__listPrices">
                              <p style={{ cursor: 'pointer', }} onClick={() => { this.saveClienteCredito( arrayListClientes[e], e ) }}>Actualizar</p>
                            </Col>
                          </Row>
                        </div>
                      ))
                    }

                  </Col>
                </Row>
              </div>
            </Modal>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={this.state.isOpenListVentaByID}
              onRequestClose={() => { this.setState({isOpenListVentaByID: false}) }}
              style={this.getStyleModal('isOpenListVentaByID')}
              contentLabel="Ventas realizadas"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>

                    <Row>
                      <Col>
                        <p>Clave</p>
                      </Col>
                      <Col>
                        <p>Nombre producto</p>
                      </Col>
                      <Col>
                        <p>Cantidad</p>
                      </Col>
                      <Col>
                        <p>Precio Venta</p>
                      </Col>
                      <Col>
                        <p>Total</p>
                      </Col>
                    </Row>

                    {
                      this.state.arrListVentaByID.map((t,e) => (
                        <Row>
                          <Col>
                            <p>{t.clave}</p>
                          </Col>
                          <Col>
                            <p>{t.nombre}</p>
                          </Col>
                          <Col>
                            <p>{this.number_format(t.venta_kg,2)}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format( ( t.venta_pesos / t.venta_kg ) ,2)}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format(t.venta_pesos,2)}</p>
                          </Col>
                        </Row>
                      ))
                    }

                    <Row>
                      <button style={{ margin: '0 auto' }} className={'btn btn-danger'}
                        onClick={() => { this.setState({ isOpenListVentaByID: false, }) }}
                      >Cerrar</button>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Modal>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={isOpenListVentaAndPagosByID}
              onRequestClose={() => { this.setState({isOpenListVentaAndPagosByID: false}) }}
              style={this.getStyleModal('isOpenListVentaAndPagosByID')}
              contentLabel="Ventas realizadas"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte" style={{ padding: 20, background: '#fff', marginBottom: 10, }}>
                  <Col>
                    <Row>
                      <Col>
                        <p>Fecha del abono</p>
                      </Col>
                      <Col>
                        <p>Efectivo</p>
                      </Col>
                      <Col>
                        <p>Débito</p>
                      </Col>
                      <Col>
                        <p>Crédito</p>
                      </Col>
                      <Col>
                        <p>Total</p>
                      </Col>
                    </Row>

                    {
                      this.state.arrListVentaAndPagosByID.pagos.map((t,e) => (
                        <Row>
                          <Col>
                            <p>{moment(t.created_at).format('DD/MM/YYYY HH:mm:ss')}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format(t.efectivo,2)}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format(t.debito,2)}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format(t.credito,2)}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format((t.total),2)}</p>
                          </Col>
                        </Row>
                      ))
                    }

                  </Col>
                </Row>
                <Row className="modalBody__corte" style={{ padding: 20, background: '#f3f3f3', marginBottom: 10, }}>
                  <Col>
                    <Row>
                      <Col>
                        <p>Clave</p>
                      </Col>
                      <Col>
                        <p>Nombre producto</p>
                      </Col>
                      <Col>
                        <p>Cantidad</p>
                      </Col>
                      <Col>
                        <p>Precio Venta</p>
                      </Col>
                      <Col>
                        <p>Total</p>
                      </Col>
                    </Row>

                    {
                      this.state.arrListVentaAndPagosByID.productos.list.map((t,e) => (
                        <Row>
                          <Col>
                            <p>{t.clave}</p>
                          </Col>
                          <Col>
                            <p>{t.nombre}</p>
                          </Col>
                          <Col>
                            <p>{this.number_format(t.venta_kg,2)}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format( ( t.credito / t.venta_kg ) ,2)}</p>
                          </Col>
                          <Col>
                            <p>${this.number_format(t.credito,2)}</p>
                          </Col>
                        </Row>
                      ))
                    }
                    <Row>
                      <button style={{ margin: '0 auto' }} className={'btn btn-danger'}
                        onClick={() => { this.setState({ isOpenListVentaAndPagosByID: false, }) }}
                      >Cerrar</button>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Modal>

            <Modal
              overlayClassName="Overlay__aplicaciones"
              isOpen={isOpenRegisterAbonoPago}
              onRequestClose={() => { this.setState({isOpenRegisterAbonoPago: false}) }}
              style={customStyles}
              contentLabel="Realizar un abono"
              >
              <div className="modalBody__operador">
                <Row className="modalBody__corte"> 
                  <Col>
                    <h4 style={{ margin: 0, marginBottom: 10, }}>Realizar un abono</h4>

                    <Row style={{ width: '60%', margin: '0 auto', }}>
                      <Col xs={'4'}>
                        <p style={{ margin:0, textAlign: 'center', marginTop: '6px', }}>Cantidad en efectivo</p>
                      </Col>
                      <Col>
                        <input
                          type="text"
                          placeholder="Ingresa la cantidad en efectivo"
                          value={this.state.cantidadRecibidaE}
                          onChange={ (event) => { this.setState({cantidadRecibidaE: event.target.value}) } }
                          ref={(input) => { this.inputCambioRecibido = input; }} 
                          style={{ marginBottom: 20, marginTop: 0, }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ width: '60%', margin: '0 auto', }}>
                      <Col xs={'4'}>
                        <p style={{ margin:0, textAlign: 'center', marginTop: '6px', }}>Cantidad en débito</p>
                      </Col>
                      <Col>
                        <input
                          type="text"
                          placeholder="Ingresa la cantidad en débito"
                          value={this.state.cantidadRecibidaTD}
                          onChange={ (event) => { this.setState({cantidadRecibidaTD: event.target.value}) } }
                          style={{ marginBottom: 20, marginTop: 0, }}
                        />
                      </Col>
                    </Row>
                    <Row style={{ width: '60%', margin: '0 auto', }}>
                      <Col xs={'4'}>
                        <p style={{ margin:0, textAlign: 'center', marginTop: '6px', }}>Cantidad en crédito</p>
                      </Col>
                      <Col>
                        <input
                          type="text"
                          placeholder="Ingresa la cantidad en crédito"
                          value={this.state.cantidadRecibidaTC}
                          onChange={ (event) => { this.setState({cantidadRecibidaTC: event.target.value}) } }
                          style={{ marginBottom: 20, marginTop: 0, }}
                        />
                      </Col>
                    </Row>

                    <p style={{ textAlign: 'right', }}>{(parseFloat(cantidadCambioCredito) >= 0 || this.number_format(cantidadCambioCredito, 2) === '0.00') ? 'CAMBIO:' : 'PENDIENTE:'} ${ this.number_format( (parseFloat(cantidadCambioCredito) >= 0 || this.number_format(cantidadCambioCredito, 2) === '0.00' ) ? cantidadCambioCredito : (parseFloat(cantidadCambioCredito) * -1) , 2) }</p>
                    <hr />
                    <button style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', background: '#2ecc71', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', marginTop: 20, display: 'block', border: 0, }}
                    onClick={ () => { this.setRegisterNewAbono() }}
                    className="regVentaPage__title">Registrar abono</button>

                    <button style={{ padding: '5px 14px', cursor: 'pointer', textAlign: 'center', color: '#fff', borderRadius: '4px', fontWeight: 600, width: '50%', margin: '0 auto', marginTop: 20, display: 'block', border: 0, }}
                    onClick={ () => { this.setState({isOpenRegisterAbonoPago: false,}) }}
                    className="regVentaPage__title btn btn-danger">Cerrar</button>

                  </Col>
                </Row>
              </div>
            </Modal>


          </div>

          <div className="initialPage__wrapper"  style={{ backgroundColor: 'transparent', display: !showProductosHoy ? 'none': 'block' }}>
            <Row style={{ width: '99%', margin: '0 auto' }}>
              <Col className={'z-depth-1'} style={{ background: '#fff', }}>
                <Row>
                  <p className="regVentaPage__product" style={{ padding: '0px', textAlign: 'center', justifyContent: 'center', alignItems: 'center', display: 'flex', height: '100%', }}>Productos cambiados hoy</p>
                </Row>
                <Row>
                  <Col xs={'5'}>
                    <b>Nombre</b>
                  </Col>
                  <Col xs={'5'}>
                    <b>Costo</b>
                  </Col>
                  <Col xs={'2'}>
                    <b>Hora de cambio</b>
                  </Col>
                </Row>

                {
                  arrListProductosHoy.map((t,e) => (
                    <Row
                      key={`ws_list_cambios_${e}`}
                      style={{ width: '100%', margin: '0 auto', marginTop: 10, marginBottom: 10, }}
                      className="regVentaPage__content"
                    >
                      <div className="regVentaPage__separator"></div>

                      <Col xs={'5'} className="regVentaPage__listProduct">
                        <p style={{ color: '#333' }}>{t.nombre}</p>
                      </Col>
                      <Col xs={'5'} className="regVentaPage__listProduct">
                        <p style={{ color: '#333' }}>${this.number_format(t.precio_venta,2)}</p>
                      </Col>
                      <Col xs={'2'} className="regVentaPage__listProduct">
                        <p style={{ color: '#333' }}>{moment(t.fecha).format('HH:mm')}</p>
                      </Col>
                    </Row>
                  ))
                }
              </Col>
            </Row>
          </div>
        </>
      );
    }  else if(renderView === 'altas') {
      if(this.props.initState.signedIn.type === 5) {
        //diferente
        return (
          <AltasGralModulePage subState={ this.state } subSetState={ (param) => this.setState(param) } initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />
        );
      } else {
        return (
          <AltasModulePage subState={ this.state } subSetState={ (param) => this.setState(param) } initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />
        );
      }
    } else if(renderView === 'altas_ruta') {
      return (
        <AltasModulePage subState={ this.state } subSetState={ (param) => this.setState(param) } initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />
      );
    } else if(renderView === 'actualiza-costos') {
      return (
        <ActualizaCostosModulePage subState={ this.state } subSetState={ (param) => this.setState(param) } initState={ this.props.initState } initsetState={ (param) => this.props.initsetState(param) } />
      );
    } else {
      return null
    }
  }

  saveClienteCredito(t,e) {
    // arrCreditosAbonosVigentes
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setUpdateCliente", this.headersPOST({ nombre: t.nombre, id_cliente: t.id_cliente, }))
    .then(response => response.json())
    .then((response) => {
      // this.setState({ arrListVentaByID: response.list })
      alert('Cambio realizado con éxito.')
    }).catch(() => {})
  }

  makeAvisoReload() {
    return (
      <div className={'ws__viewUpdate'}>
        <h3>Algunos costos han cambiado</h3>
        <p>Por favor, actualiza este punto de venta para continuar realizando ventas.</p>
        <button className={'btn btn-primary'} onClick={() => {
          window.location.reload()
        }}>Actualizar</button>
      </div>
    )
  }

  getListProductosByID(id_pago) {
    this.setState({ isOpenListVentaByID: true, arrListVentaByID: [], })
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getListProductosByID", this.headersPOST({ id_pago, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrListVentaByID: response.list })
    })
  }

  /*
  * MODULO ABONOS
  */

  getListProductosAndPagosByID(id_pago) {
    this.setState({ isOpenListVentaAndPagosByID: true, })
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getListProductosAndPagosByID", this.headersPOST({ id_pago, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrListVentaAndPagosByID: response })
    })
  }

  setRegisterAbono(e) {
    const { arrCreditosAbonosVigentes } = this.state
    this.setState({ cantidadTotalCredito: arrCreditosAbonosVigentes.creditos[e].residual, indexAbonoPago: e, isOpenRegisterAbonoPago: true, })
  }

  setRegisterNewAbono(e) {
    const { signedIn, url_facturacion, } = this.props.initState
    let { arrCreditosAbonosVigentes, indexAbonoPago, cantidadRecibidaTC, cantidadRecibidaTD, cantidadRecibidaE, cantidadTotalCredito, } = this.state

    let residualEfectivo = 0
    let cantidadCambio = ((parseFloat(cantidadRecibidaE == '' ? 0 : cantidadRecibidaE) + parseFloat(cantidadRecibidaTD == '' ? 0 : cantidadRecibidaTD) + parseFloat(cantidadRecibidaTC == '' ? 0 : cantidadRecibidaTC) ) - cantidadTotalCredito )

    if(cantidadCambio < 0 && this.number_format(cantidadCambio,2) !== '0.00') {
      //Permitimos que abone sin forzar el pago total
      residualEfectivo = cantidadRecibidaE
    } else {

      residualEfectivo = (((parseFloat(cantidadRecibidaTD == '' ? 0 : cantidadRecibidaTD) + parseFloat(cantidadRecibidaTC == '' ? 0 : cantidadRecibidaTC) ) - cantidadTotalCredito ) * -1)
    }

    let data = {
      id_pago: arrCreditosAbonosVigentes.creditos[indexAbonoPago].id_pago,
      id_sucursal: signedIn.id_sucursal,
      id_vendedor: signedIn.id_usuario,
      nombre_cajero: (signedIn.nombre + ' ' + signedIn.apellidos),
      folio: arrCreditosAbonosVigentes.creditos[indexAbonoPago].folio,
      nombreClienteCredito: arrCreditosAbonosVigentes.creditos[indexAbonoPago].nombreClienteCredito,
      url_facturacion,
      codigo_unico: arrCreditosAbonosVigentes.creditos[indexAbonoPago].codigo_unico,
      printerActive: true,
      cantidadRecibidaE: residualEfectivo,
      cantidadRecibidaTD,
      cantidadRecibidaTC,
      cantidadTotalCredito,
    }

    this.setState({ isOpenRegisterAbonoPago: false, })

    fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRegisterNewAbono", this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterNewAbono", this.headersPOST({ ...data, }))
      .then(response0 => response0.json())
      .then((response0) => {

        // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 2, })
        this.setBindCreditosAbonos(2)
        this.setState({
          cantidadRecibidaE: 0,
          cantidadRecibidaTD: 0,
          cantidadRecibidaTC: 0,
        })

      }).catch((err) => {})

    }).catch((err) => {

      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterNewAbono", this.headersPOST({ ...data, }))
      .then(response0 => response0.json())
      .then((response0) => {

        // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 2, })
        this.setBindCreditosAbonos(2)
        this.setState({
          cantidadRecibidaE: 0,
          cantidadRecibidaTD: 0,
          cantidadRecibidaTC: 0,
        })

      }).catch((err) => {})


    })


  }

  /**
  * MODULO DEVOLUCIONES
  **/

  setDevolucionVentaByID(id_pago) {
    var opcion = window.confirm("¿Estás seguro que deseas realizar una devolución de esta venta?");
    if (opcion == true) {
      const { signedIn, id_vendedor, id_sucursal, } = this.props.initState

      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setDevolucionVentaByID", this.headersPOST({
        id_pago,
        id_vendedor,
        id_sucursal,
      }))
      .then(response => response.json())
      .then((response) => {
        // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 2, })
        alert('Devolución realizada con éxito.')
        this.setBindLastVentas()
      })
    }
  }

  setDeleteVentaByID(id_pago) {
    var opcion = window.confirm("¿Estás seguro que deseas eliminar esta venta registrada?");
    if (opcion == true) {
      const { signedIn } = this.props.initState

      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setDeleteVentaByID", this.headersPOST({ id_pago, }))
      .then(response => response.json())
      .then((response) => {
        // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 2, })
        this.setBindLastVentas()
      })
    }
  }

  /**
  * BUSCAR PRODUCTO
  **/

  onViewProduct(val) {
    let { arrayListProductos } = this.state

    this.setState({ valSearch: val })
    let countLimit = 0

    arrayListProductos = arrayListProductos.filter(function(producto, index) {
      if(countLimit <= 30) {
        if(typeof producto.nombre === 'undefined' || !producto.nombre) {
        } else {
          if(producto.nombre && producto.nombre.toLowerCase().indexOf(val.toLowerCase()) !== -1) {
            countLimit++
            return true
          }
        }
      }
    });
    this.setState({ arrayListResults: arrayListProductos });
  }

  /**
  * Buscar código por producto
  **/

  _handleKeyDown(e) {
    if(e.key === 'Enter') {
      this.onSearchProductoByCode()
    }
  }

  onSearchProductoByCode() {
    let { arrListVenta, arrayListProductos, valSearchByFullCode, } = this.state
    const { signedIn } = this.props.initState

    if(valSearchByFullCode.trim() == '')
      return false

    let countLimit = 0,
    searchFirstByIntCodes = '',
    index = -1,
    cantidad = '',
    isCodeBascula = false,
    separator = ''

    for(var a in arrayListProductos) {
      if(arrayListProductos[a].folio == valSearchByFullCode) {
        index = a
        break;
      }
    }

    if(valSearchByFullCode.length == 13 && index == -1) {
      //Probable código de barras
      separator = valSearchByFullCode.split('')
      valSearchByFullCode = (separator[2] + '' + separator[3] + '' + separator[4] + '' + separator[5] + '' + separator[6])

      for(var a in arrayListProductos) {
        if(arrayListProductos[a].folio == valSearchByFullCode) {
          index = a
          break;
        }
      }

      if(index > -1) {
        //Si ya encontró un index entonces proviene de báscula
        // Código registrado desde báscula [ disponible para INGENIO ]
        // 0 1 2 3 4 5 6 7 8 9 0 1 2
        // 2 0 0 0 0 4 3 0 1 0 0 0 2
        // 2 0 0 0 0 0 1 0 1 0 0 0 2
        // 2 0 0 0 0 9 0 0 0 0 0 1 8

        cantidad = parseFloat(separator[7] + '' + separator[8] + '.' + separator[9] + '' + separator[10] + '' + separator[11]);
        if((separator[7] + '' + separator[8] + '.' + separator[9] == '00.0')) {
          if( parseInt(separator[10] + '' + separator[11]) < 25 )
            cantidad = parseInt(separator[10] + '' + separator[11]);
        }
        isCodeBascula = true
      }
    }


    for(var a in arrayListProductos) {
      if(arrayListProductos[a].folio == valSearchByFullCode) {
        index = a
        break;
      }
    }

    if(index > -1) {
      let t = arrayListProductos[index]

      if(isCodeBascula && arrListVenta.length > 0) {
        if( arrListVenta[ arrListVenta.length - 1 ].id_producto == t.id_producto
          && arrListVenta[ arrListVenta.length - 1 ].cantidad == cantidad ) {
          this.setState({ valSearchByFullCode: '', })
          return false
        }
      }

      let newItem = [{
        nombre: t.nombre,
        only_nombre: t.only_nombre,
        applyOnlyBuy: true,
        canEditProduct: false,
        folio: t.folio,
        cantidad,
        precio_compra: t.precio_compra,
        precio: t.precio_venta,
        update: t.update,
        id_producto: t.id_producto,
        version: 'v3.0.0',
        precio_original: t.precio_venta,
      }]
      arrListVenta = [ ...arrListVenta, ...newItem ]

      this.setState({
        arrListVenta,
        isOpenSearchProducto: false,
        valSearch: '',
        valSearchByFullCode: '',
      })

      setTimeout(() => {
        const index0 = arrListVenta.length - 1

        if(isCodeBascula) {
          this.inputSearchByCode.focus();
        } else {
          this[`inputVentaID${(index0)}`].focus();
        }

        document.getElementById("root").firstElementChild.scrollIntoView(false);



        if(arrListVenta.length === 1) {
          // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 1, })
        }
      }, 100)
      // this.inputSearchByCode.focus(); 
    } else {
    }

  }

  onChangeInputValues(opt, index, value) {
    let { arrayListResults } = this.state

    if(opt === 1) {
      arrayListResults[index].precio_compra = value
    } else {
      arrayListResults[index].precio_venta = value
    }

    this.setState({ arrayListResults })
  }

  deleteItemProduct(e) {
    let { arrListVenta, } = this.state
    const { signedIn } = this.props.initState
    const arr = arrListVenta.filter(function(item, index) { return index !== e })

    this.setState({
      arrListVenta: arr,
      valSearch: '',
    })

    if(arr.length === 0) {
      // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 0, })
    }

  }

  selectItemProduct(e) {
    let { arrListVenta, arrayListResults } = this.state
    const { signedIn } = this.props.initState
    const t = arrayListResults[e]

    let newItem = [{
      nombre: t.nombre,
      only_nombre: t.only_nombre,
      applyOnlyBuy: true,
      canEditProduct: false,
      folio: t.folio,
      cantidad: '',
      precio: t.precio_venta,
      update: t.update,
      id_producto: t.id_producto,
      version: 'v3.0.0',
      precio_original: t.precio_venta,
    }]
    arrListVenta = [ ...arrListVenta, ...newItem ]

    this.setState({
      arrListVenta,
      isOpenSearchProducto: false,
      valSearch: '',
    })

    setTimeout(() => {
      this.props.initsetState({ renderView: 'nuevaCompraRuta', })
      const index = arrListVenta.length - 1
      this[`inputVentaID${(index)}`].focus();
    }, 100)

    if(arrListVenta.length === 1) {
      //Si es el primer item agregado mandar notificación
      // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 1, })
    }

  }

  /**
  * CONCLUIR COMPRA
  **/

  onUpdateCantidad(t, e, value) {
    let { arrListVenta } = this.state
    arrListVenta[e].cantidad = value
    this.setState({ arrListVenta })
  }
  
  onUpdateFolio(t, e, value) {
    let { arrListVenta } = this.state
    arrListVenta[e].folio = value
    this.setState({ arrListVenta })
  }

  onUpdatePrecio(t, e, value) {
    let { arrListVenta } = this.state
    arrListVenta[e].precio = value
    this.setState({ arrListVenta })
  }

  onUpdateBuy(e, t) {
    let { arrListVenta } = this.state
    arrListVenta[e].applyOnlyBuy = t
    this.setState({ arrListVenta })
  }
  
  onEditValuesProduct(e, t) {
    let { arrListVenta } = this.state
    arrListVenta[e].canEditProduct = t
    this.setState({ arrListVenta })
  }

  onRegisterNewVenta() {
    const { signedIn, url_facturacion, id_vendedor, id_sucursal, printerActive } = this.props.initState
    const { date, nameCliente, fpago, nombreClienteCredito, genero, email, arrListVenta,
      cantidadRecibidaE, cantidadRecibidaTD, cantidadRecibidaTC, id_despachador, nombre_despachador, id_sucursal_destino,
      f_razon_social, f_rfc, f_telefono, f_email, f_direccion_calle, f_direccion_colonia, f_direccion_noext, f_direccion_noint, f_direccion_cp,
      f_direccion_ciudad, f_direccion_estado, typePersonFactura, chBoxFacturarCompra,
    } = this.state


    if(fpago === 4 && nombreClienteCredito.id_cliente === '' || (nombreClienteCredito.id_cliente === '0' && nombreClienteCredito.nombre === '' && nombreClienteCredito.rfc === '')) {
      alert('Por favor, ingresa el nombre del cliente que recibirá crédito.')
      return false
    }

    let cantidadTotal = 0
    arrListVenta.map((t) => { cantidadTotal += ( t.precio * t.cantidad )})

    let residualEfectivo = 0
    let cantidadCambio = ((parseFloat(cantidadRecibidaE == '' ? 0 : cantidadRecibidaE) + parseFloat(cantidadRecibidaTD == '' ? 0 : cantidadRecibidaTD) + parseFloat(cantidadRecibidaTC == '' ? 0 : cantidadRecibidaTC) ) - cantidadTotal )

    if(fpago < 4) {
      if(cantidadCambio < 0 && this.number_format(cantidadCambio,2) !== '0.00') {
        alert(`Por favor, ingresa la cantidad pendiente: $${this.number_format( (cantidadCambio * -1), 2 )}`)
        return false
      }
      residualEfectivo = (((parseFloat(cantidadRecibidaTD == '' ? 0 : cantidadRecibidaTD) + parseFloat(cantidadRecibidaTC == '' ? 0 : cantidadRecibidaTC) ) - cantidadTotal ) * -1)
    }

    if(chBoxFacturarCompra) {
      //Si habilitó que desea realizar una factura
      if(typePersonFactura === 0) {
        alert('Por favor elige el tipo de persona.')
        return false
      }

      if(f_razon_social.trim() === '' || f_rfc.trim() === '' || f_telefono.trim() === '') {
        alert('Por favor ingresa los datos, "Razón social", "RFC", "Teléfono".')
        return false
      }
    }


    let data = {
      id_pago: this.uniqid(),
      date,
      dateRegister: moment().format('YYYY-MM-DD HH:mm:ss'),
      dateRegisterFormatted: moment().format('DD/MM/YYYY HH:mm:ss'),
      arr: arrListVenta,
      id_vendedor,
      id_sucursal,
      id_sucursal_destino,
      nombreClienteCredito,
      nameCliente,
      id_despachador,
      nombre_despachador,
      nombre_cajero: (signedIn.nombre + ' ' + signedIn.apellidos),
      typeUser: signedIn.type,
      fpago,
      genero,
      prioridad: 1,
      printerActive,
      cantidadRecibidaEfectivoTotal: cantidadRecibidaE,
      cantidadRecibidaE: residualEfectivo, cantidadRecibidaTD, cantidadRecibidaTC,
      chBoxFacturarCompra,
      url_facturacion,
      codigo_unico: this.getRandomString(5),
      cantidadCambio,
      typePersonFactura,
      f_razon_social,f_rfc,f_telefono,f_email,f_direccion_calle,f_direccion_colonia,
      f_direccion_noext,f_direccion_noint, f_direccion_cp,f_direccion_ciudad,f_direccion_estado,
      folio: this.state.numVentaGlobal,
    }

    this.setState({ isOpenPagarCompra: false, canPressF8: false, })


    // Second send to server register buy and destroy local file
    this.resetPoint()
    setTimeout(() => {
      this.inputSearchByCode.focus();
    }, 1000)
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=setRegisterNewVenta", this.headersPOST({ ...data, }))
    .then(response0 => response0.json())
    .then((response0) => {

      fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRegisterNewVenta", this.headersPOST({...data}))
      .then(response => response.json())
      .then((response) => {

        if (window.confirm(`Impresión realizada con éxito. ¿Deseas volver a imprimir?`)) {
          fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setRegisterNewVenta", this.headersPOST({...data}))
          .then(response => response.json())
          .then((response) => {
          })
        }

      })


      /*
      let data2 = {
        date,
        id_usuario: signedIn.id_usuario,
        nombre_cajero: (signedIn.nombre + ' ' + signedIn.apellidos),
        id_pago: data.id_pago,
      }
      fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getLastVentasByID", this.headersPOST({ ...data2, }))
      .then(response => response.json())
      .then((response) => {

        let t = response[0]

        fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getListProductosByID", this.headersPOST({ id_pago: t.id_pago, }))
        .then(response => response.json())
        .then((response) => {
          t.arr = response
          t.printerActive = this.props.initState.printerActive
          fetch("http://127.0.0.1/REST/controllers/controllerLocal.php?opt=setPrintLastVenta", this.headersPOST({...t}))
          .then(response0 => response0.json())
          .then((response0) => {alert('Impresión realizada')})
        })
      })
      */


      if(response0.status == 'ok') {
        // this.props.initState.socket.emit("toDirector", { contractor: 'hg', substrace: 'updateVentaPoS', signedIn, opt: 2, })
      }
      // alert('Venta registrada con éxito')
    }).catch((error) => {
      setTimeout(() => {  }, 500)
      console.info(error)
    });

  }

  resetPoint() {
    this.setState({
      arrListVenta: [],
      id_despachador: '',
      nombre_despachador: '',
      nameCliente: '',
      fpago: 1,
      genero: 1,
      prioridad: 1,
      email: '',
      isOpenPagarCompra: false,
      printerActive: 1,
      nombreClienteCredito: { id_cliente: '', nombre: '', },
      arrCreditosAbonosVigentes: { clientes: [], creditos: [], index: -1, search: '', },
      arrayListClientes: [],
      chBoxFacturarCompra: false,
      cantidadRecibidaE: 0,
      cantidadRecibidaTD: 0,
      cantidadRecibidaTC: 0,
      typePersonFactura: 0,
      f_razon_social: '',
      f_rfc: '',
      f_telefono: '',
      f_email: '',
      f_direccion_calle: '',
      f_direccion_colonia: '',
      f_direccion_noext: '',
      f_direccion_noint: '',
      f_direccion_cp: '',
      f_direccion_ciudad: '',
      f_direccion_estado: '',
      numVentaGlobal: (parseInt(this.state.numVentaGlobal) + 1),
    })
    setTimeout(() => {
      this.setState({
        canPressF8: true,
      })
    }, 1000)
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

  getStyleModal(opt) {
    if(opt === 'isOpenListVentaByID') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '50%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  getRandomString($length) {
    let $cadena     = "";
    let $caracteres = "1234567890";
    let $max        = $caracteres.length - 1 ;
    $cadena    += $caracteres[this.mt_rand(0,$max-1)];

    for(let $i = 0; $i < $length-1; $i++)
      $cadena += $caracteres[this.mt_rand(0,$max)];
    return moment().format('YYMMDD') + '' + $cadena;
  }

  mt_rand (min, max) {
    const argc = arguments.length
    if (argc === 0) {
      min = 0
      max = 2147483647
    } else if (argc === 1) {
      throw new Error('Warning: mt_rand() expects exactly 2 parameters, 1 given')
    } else {
      min = parseInt(min, 10)
      max = parseInt(max, 10)
    }
    return Math.floor(Math.random() * (max - min + 1)) + min
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }

};

export default withRouter(RegistrosVentasPage)
